import { render, staticRenderFns } from "./StudentAdmissionDetailBoard.vue?vue&type=template&id=aec9a0b6&scoped=true"
import script from "./StudentAdmissionDetailBoard.vue?vue&type=script&lang=js"
export * from "./StudentAdmissionDetailBoard.vue?vue&type=script&lang=js"
import style0 from "./StudentAdmissionDetailBoard.vue?vue&type=style&index=0&id=aec9a0b6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec9a0b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aec9a0b6')) {
      api.createRecord('aec9a0b6', component.options)
    } else {
      api.reload('aec9a0b6', component.options)
    }
    module.hot.accept("./StudentAdmissionDetailBoard.vue?vue&type=template&id=aec9a0b6&scoped=true", function () {
      api.rerender('aec9a0b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/specialist-availability-calendar/components/StudentAdmissionDetailBoard.vue"
export default component.exports